import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';
  obj = {};

  constructor(public http: HttpClient) {
  }

  refreshRestorePointsVm(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/refreshRestorePoints';
    return this.http
      .post(url, JSON.stringify(this.obj))
      .map(
        (res:any) => this.value = res
      );
  }

  refreshRestorePointsDeletedVm(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/deletedVm/' + vmId + '/refreshRestorePoints';
    return this.http
      .post(url, JSON.stringify(this.obj))
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/refresh-restore/refresh-restore.service.ts